import { FC } from 'react';

import { ImageAvatarPlaceholder } from '~/assets/images';
import { useAuth } from '~/hooks/auth';

import AccountDropdown from './AccountDropdown';

import {
  Container,
  IconMenu,
  Title,
  UserProfileImage,
  Username,
  Perfil,
  IconArrowDown,
  Wrapper,
} from './styles';

interface HeaderProps {
  title: string;
  toggleSidebar: () => void;
}

const Header: FC<HeaderProps> = ({ title, toggleSidebar }) => {
  const { user } = useAuth();

  return (
    <Container>
      <Wrapper>
        <IconMenu color="#000" size={32} onClick={toggleSidebar} />

        <Title>{title}</Title>
      </Wrapper>

      <Wrapper>
        <UserProfileImage
          src={user.image_url ?? ImageAvatarPlaceholder}
          alt="user-profile-img"
        />

        <Username>{user.name}</Username>

        <Perfil>
          <IconArrowDown />
          <AccountDropdown />
        </Perfil>
      </Wrapper>
    </Container>
  );
};

export default Header;
